import { useEffect } from "react";

const TrainingRedirect = () => {
  useEffect(() => {
    window.location.replace("/training.html");
  }, []);
  return (
    <div data-testid="training-redirect" style={{ minHeight: "100vh", background: "#0A1E3F" }} />
  );
};

export default TrainingRedirect;
